import { ReactElement } from "react";

import { Classes, IconName } from "@blueprintjs/core";

import { RichContentRenderer } from "@/components/helpers/ui/RichContentRenderer";
import { IconCircle } from "@/components/pieces/IconCircle";
import { LIGHT_STEEL_GRAY, MIDTEXT_COLOR } from "@/css/constants";

interface FeedbackCardProps {
  icon: IconName | ReactElement;
  title: string;
  content?: string | null;
  iconColor: string;
}

export function FeedbackCard({
  icon,
  title,
  content,
  iconColor,
}: FeedbackCardProps) {
  return (
    <div
      className="p-6 round-corners"
      style={{ backgroundColor: LIGHT_STEEL_GRAY }}
    >
      <div className="flex items-center">
        <IconCircle
          icon={icon}
          backgroundColor="#FFF"
          color={iconColor}
          size={30}
          iconSize={16}
        />
        <div className="ml-2 font-medium">{title}</div>
      </div>
      <div
        className={`mt-3 ${Classes.RUNNING_TEXT}`}
        style={{ color: MIDTEXT_COLOR }}
      >
        <RichContentRenderer content={content} />
      </div>
    </div>
  );
}
